// src/components/RegisterTwo.jsx
import { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import "./registertwo.css";

const RegisterTwo = () => {
  const { user } = useContext(AuthContext);

  // Si ya hay un usuario autenticado, redirige a "mi-cuenta", de lo contrario a la ruta de registro para usuario.
  const targetLink = user ? "/mi-cuenta" : "/register?role=user";

  return (
    <section className="register-section2">
      <div className="register-overlay">
        <div className="register-content">
          <h2>REGÍSTRATE</h2>
          <p>Y obtén resultados personalizados.</p>
          <Link to={targetLink} className="btn btn-danger">
            REGÍSTRATE AQUÍ
          </Link>
        </div>
      </div>
    </section>
  );
};

export default RegisterTwo;